export default __webpack_public_path__ + "static/0302-2aff038600db55ad3725a1d467809cdc.png";